(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
